import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import { withAlert } from 'react-alert';
import LoadingModal from '../../components/LoadingModal';
import ErrorList from '../../components/ErrorList';

class PromocodeScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { promocode: null, loading: false };
    }

    onSubmit() {
        let { promocode } = this.state;
        //allow the user to continue without a promocode
        if (!promocode) {
            promocode = 'SKIP';
        }
        this.setState({ loading: true });
        this.submitPromocode(promocode)
            .then(response => {
                if (response.success) {
                    // address and promocode success
                    this.goToNextPage();
                } else {
                    // Address success but Promocode or Referral incorrect
                    this.setState({ promocodeError: 'This promocode is invalid', loading: false });
                }
            })
            .catch(() => {
                this.setState({ promocodeError: 'This promocode is invalid', loading: false });
            });
    }

    goToNextPage = () =>
        AuthService.getAccountStatus().then(response => {
            if (response.next === null) {
                this.props.history.push('/status');
            } else {
                this.props.history.push(response.next);
            }
        });

    submitPromocode = promocode => AuthService.submitPromocode(promocode);

    cancel() {
        AuthService.getAccountStatus().then(response => {
            response.steps.forEach((entry, i) => {
                if (entry.path === this.props.location.pathname) {
                    if (entry.back) {
                        this.props.history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            this.props.history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    }

    render() {
        const { promocodeError, isLoading } = this.state;

        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column justify-content-center full-height">
                    <div>
                        <h3 className="page__title-medium">{window.VULOG_TRANSLATE('Set a promocode')}</h3>
                        <React.Fragment>
                            {promocodeError && <p className={'form__errors danger'}>{promocodeError}</p>}
                            <div className="form-row mb-4">
                                <label htmlFor="promo-code" className="blue small col-4 mb-0">
                                    {window.VULOG_TRANSLATE('Promo Code')}
                                </label>
                                <div className="col">
                                    <input
                                        name={'promo-code'}
                                        value={this.state.promocode}
                                        onChange={e => {
                                            this.setState({
                                                promocode: e.target.value,
                                            });
                                        }}
                                        type="text"
                                        className="form-control"
                                        id="promo-code"
                                        disabled={!!this.state.next}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    </div>

                    <div className="d-flex flex-row mt-auto mb-1-5rem">
                        {this.props.position !== window.VULOG_CONFIG.STEPS[1].screen ? (
                            <button onClick={() => this.cancel()} className="btn btn-primary btn-block">
                                <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                                {window.VULOG_TRANSLATE('Back')}
                            </button>
                        ) : null}
                        <button
                            className="btn btn-primary btn-block"
                            onClick={() => this.onSubmit()}
                            disabled={isLoading}
                        >
                            {window.VULOG_TRANSLATE('Next')}
                            <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                        </button>
                    </div>
                    <LoadingModal loading={this.state.loading} message={'PROMOCODE_LOADING_MESSAGE'} />

                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                        <ErrorList errors={this.state.errors} hide={this.state.errors.length === 0} />
                    )}
                </div>
            </div>
        );
    }
}

export default withAlert(PromocodeScreen);
